<template>
  <OPagination
    class="nr-pagination"
    v-bind="$props"
    @change="onChange"
    @update:current="onUpdate"
  >
    <template #next="props">
      <OPaginationButton :page="props.page">
        <NrIcon :name="iconNext" />
      </OPaginationButton>
    </template>
    <template #previous="props">
      <OPaginationButton :page="props.page">
        <NrIcon :name="iconPrev" />
      </OPaginationButton>
    </template>
  </OPagination>
</template>

<script>
import NrIcon from '../NrIcon'
import OPagination from '@oruga-ui/oruga-next/src/components/pagination/Pagination.vue'
import OPaginationButton from '@oruga-ui/oruga-next/src/components/pagination/PaginationButton.vue'

export default {
  name: 'NrPagination',
  components: { OPagination, OPaginationButton, NrIcon },
  props: {
    /** Total count of items */
    total: [Number, String],
    /** Items count for each page */
    perPage: {
      type: [Number, String],
      default: 20
    },
    /** Current page number */
    current: {
      type: [Number, String],
      default: 1
    },
    /** Number of pagination items to show before current page */
    rangeBefore: {
      type: [Number, String],
      default: 1
    },
    /** Number of pagination items to show after current page */
    rangeAfter: {
      type: [Number, String],
      default: 1
    },
    /** Simple style */
    simple: Boolean,
    /**
     * Buttons order, optional
     * @values centered, right, left
     */
    order: {
      type: String,
      default: 'left'
    },
    /** Icon to use for previous button */
    iconPrev: {
      type: String,
      default: 'chevron-left'
    },
    /** Icon to use for next button */
    iconNext: {
      type: String,
      default: 'chevron-right'
    },
    ariaNextLabel: String,
    ariaPreviousLabel: String,
    ariaPageLabel: String,
    ariaCurrentLabel: String
  },
  methods: {
    onChange(val) {
      this.$emit('change', val)
    },
    onUpdate(val) {
      this.$emit('update', val)
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/tokens/tokens.scss';
.nr-pagination {
  display: flex;
  &.o-pag--simple {
    .o-pag__info {
      padding-top: $spacing-6;
      font-weight: $font-weight-semibold;
      font-size: $font-size-3;
      margin-right: $spacing-4;
    }
  }
  &.o-pag--left {
    .o-pag__previous {
      order: 2;
    }
    .o-pag__next {
      order: 3;
    }
    ul {
      order: 1;
    }
  }
  &.o-pag--right {
    .o-pag__previous {
      order: 1;
    }
    .o-pag__next {
      order: 2;
    }
    ul {
      order: 3;
      li {
        a[role='button'] {
          margin-left: $spacing-4;
        }
      }
    }
  }
  &.o-pag--centered {
    .o-pag__previous {
      order: 1;
    }
    .o-pag__next {
      order: 3;
    }
    ul {
      justify-content: center;
      flex-grow: 1;
      flex-shrink: 1;
      order: 2;
    }
  }
  .o-pag__previous {
    margin-right: $spacing-4;
  }
  .o-pag__previous,
  .o-pag__next {
    height: 34px;
    width: 34px;
    font-size: $font-size-5;
    line-height: $font-lineheight-3;
    padding: $spacing-4 $spacing-4;
    font-family: $font-family;
    font-weight: $font-weight-semibold;
    text-decoration: none;
    border: $border-width-default solid transparent;
    border-radius: $border-radius-default;
    cursor: pointer;
    .nr-icon {
      text-align: center;
      align-items: center;
    }
    background-color: $color-white;
    color: $color-blue-100;
    border-color: $color-blue-100;
    &:hover:not(:disabled) {
      color: $color-blue-80;
      border-color: $color-blue-80;
    }
  }
  .o-pag__link--disabled {
    opacity: $opacity-20;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      display: flex;
      a[role='button'] {
        height: 34px;
        margin-right: $spacing-4;
        font-size: $font-size-3;
        line-height: $font-lineheight-3;
        padding: $spacing-4 $spacing-16;
        font-family: $font-family;
        font-weight: $font-weight-semibold;
        text-decoration: none;
        border: $border-width-default solid transparent;
        border-radius: $border-radius-default;
        cursor: pointer;
        text-align: center;
        align-items: center;
        background-color: $color-white;
        color: $color-blue-100;
        border-color: $color-blue-100;
        &.o-pag__link--current {
          color: $color-white;
          background-color: $color-blue-100;
          border-color: $color-blue-100;
          &:hover:not(:disabled) {
            background-color: $color-blue-80;
            color: $color-white;
          }
        }
        &:hover:not(:disabled) {
          border-color: $color-blue-80;
          color: $color-blue-80;
        }
      }
      .o-pag__ellipsis {
        text-align: center;
        pointer-events: none;
        margin-left: $spacing-4;
        margin-right: $spacing-8;
        padding-top: $spacing-4;
      }
    }
  }
}
</style>
